/* eslint-disable */
import React from "react";
import "./HomeSections.css";

function HomeSections() {
    const sections = [
        {
            id: 1,
            title: "Fresh Jumbo Size Afghan Dry Figs",
            description: "Struggling to find high-quality figs in India? Look no further! Afghan Dry Fruit Delights delivers premium Afghan dry figs in bulk across India. Order now and experience top quality figs for your business.",
            image: "images/slides/banner1.png",
            variant: "style-one",
        },
        {
            id: 2,
            title: "Akbar Cardamom (8 mm & above)",
            description: "Cardamom is the Queen of Spices. Yet, this wonder spice does more than just add flavour to food and beverages. It also has excellent and multiple medicinal properties, is used in perfumes, is chewed as a mouth freshener and makes for a very thoughtful gift.",
            image: "images/slides/banner2.png",
            reverse: true,
            variant: "style-two",
        },
        {
            id: 3,
            title: "Akbar Cardamom (8 mm & above)",
            description: "Cardamom is the Queen of Spices. Yet, this wonder spice does more than just add flavour to food and beverages. It also has excellent and multiple medicinal properties, is used in perfumes, is chewed as a mouth freshener and makes for a very thoughtful gift.",
            image: "images/slides/banner3.png",
            variant: "style-three",
        },
    ];

    return (
        <>
            {sections.map((section) => (
                <section style={{marginBottom: "5%"}}
                    key={section.id}
                    className={`home-section ${section.variant} ${section.reverse ? "reverse" : ""}`}
                >
                    <div className="section-content">
                        <h2>{section.title}</h2>
                        <p>{section.description}</p>
                    </div>

                    <div className="section-image">
                        <img src={section.image} alt={section.title} />
                    </div>
                </section>
            ))}
        </>
    );
}

export default HomeSections;
